import { Thunk } from 'ha/myredux/types';
import { GlobalState } from 'ha/types/store';
import { getCurrentLanguageCode } from 'ha/modules/LanguageSwitcher/selectors';

import { Actions } from './actions';

type Load = () => Thunk<GlobalState>;

// eslint-disable-next-line import/prefer-default-export
export const load: Load = () => (dispatch, getState, services) => {
  dispatch(Actions.start());

  const lang = getCurrentLanguageCode(getState());

  return services.apiV2
    .getFeaturedCities({ lang })
    .then(({ data: { cities } }) => {
      dispatch(Actions.done(cities));
    })
    .catch(error => {
      dispatch(Actions.fail(error));
    });
};
